import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../services/api'

const CoursesOne = () => {
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchExams = async () => {
            try {
                const response = await api.exams.getAll();
                if (response.success) {
                    // Get basic exam details first
                    let formattedExams = response.data.map(exam => {
                        // Format date
                        const createdAt = new Date(exam.createdAt);
                        const formattedDate = createdAt.toLocaleDateString('en-US', { 
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                        });
                        
                        return {
                            ...exam,
                            formattedDate,
                            questionCount: exam.questions?.length || 0,
                            participantsCount: 0 // Will be updated with real data
                        };
                    });
                    
                    // Only process the first 5 exams for dashboard display
                    const displayExams = formattedExams.slice(0, 5);
                    
                    // Fetch participant counts for each exam
                    const examsWithParticipants = await Promise.all(
                        displayExams.map(async (exam) => {
                            try {
                                if (exam._id) {
                                    const resultsResponse = await api.exams.getResultsByExamId(exam._id);
                                    if (resultsResponse.success) {
                                        return {
                                            ...exam,
                                            participantsCount: resultsResponse.data.length
                                        };
                                    }
                                }
                                return exam;
                            } catch (error) {
                                console.error(`Error fetching results for exam ${exam._id}:`, error);
                                return exam;
                            }
                        })
                    );
                    
                    setExams(examsWithParticipants);
                }
            } catch (error) {
                console.error('Error fetching exams:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchExams();
    }, []);

    return (
        <div className="col-xxl-8">
            <div className="card h-100">
                <div className="card-header">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg mb-0">Exams</h6>
                        <Link
                            to="/admin/exams"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link>
                    </div>
                </div>
                <div className="card-body p-24">
                    {loading ? (
                        <div className="text-center py-4">Loading exams data...</div>
                    ) : exams.length === 0 ? (
                        <div className="text-center py-4">No exams found</div>
                    ) : (
                        <div className="table-responsive scroll-sm">
                            <table className="table bordered-table mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">Created On</th>
                                        <th scope="col">Creator</th>
                                        <th scope="col">Exam Details</th>
                                        <th scope="col">Participants</th>
                                        <th scope="col">Duration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {exams.map((exam, index) => (
                                        <tr key={exam._id || index}>
                                            <td>
                                                <span className="text-secondary-light">{exam.formattedDate}</span>
                                            </td>
                                            <td>
                                                <span className="text-secondary-light">{exam.createdBy?.name || 'Administrator'}</span>
                                            </td>
                                            <td>
                                                <div className="text-secondary-light">
                                                    <h6 className="text-md mb-0 fw-normal">
                                                        {exam.title || `Exam #${index + 1}`}
                                                    </h6>
                                                    <span className="text-sm fw-normal">{exam.questionCount} Questions</span>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="text-secondary-light">{exam.participantsCount}</span>
                                            </td>
                                            <td>
                                                <span className="text-secondary-light">{exam.duration || '60'} mins</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CoursesOne